module.exports = __webpack_public_path__ + "img/shilov.93b0452d.png";